import React from 'react';
import "./sidebar.css";
import SidebarRow from './SidebarRow';
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import EmojiFlagsIcon from "@material-ui/icons/EmojiFlags";
import PeopleIcon from "@material-ui/icons/People";
import ChatIcon from "@material-ui/icons/Chat";
import { useStateValue } from './StateProvider';

function Sidebar() {
    const[{user},dispatch] = useStateValue();
    return (
        <div>
            <SidebarRow src={user.photoURL} title ={user.displayName} />
            <SidebarRow Icon={LocalHospitalIcon} title='COVID-19 Information Center' />
            <SidebarRow Icon={EmojiFlagsIcon} title='Pages' />
            <SidebarRow Icon={PeopleIcon} title="Friends"/>
            <SidebarRow Icon= {ChatIcon} title='Messenger'/>
        </div>
    )
}

export default Sidebar
